import {sku4ring} from '../logic/sku-ver3';

export  default function imageLogic (state,view) {
  if (view === undefined)
    view=1
 let base_url=state.view_image_base;
 if (view === 1) return base_url+sku4ring(state['sku']) +'.jpg?v=1'
 if (view === 2) return base_url+sku4ring(state['sku']) +'.jpg?v=2'
 if (view === 3) return base_url+sku4ring(state['sku']) +'.jpg?v=3'
 if (view === 4) return base_url+sku4ring(state['sku']) +'.jpg?v=4'
 if (view === 5) return base_url+sku4ring(state['sku']) +'.jpg?v=5'
 if (view === 5) return base_url+sku4ring(state['sku']) +'.jpg?v=6'

    var today = new Date();
    var datehour = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate()+'-'+today.getHours();
    base_url+=state['sku'] +'.jpg?v='+view.toString() + '&time=' + datehour
    
  return base_url
  }


// WEBPACK FOOTER //
// ./src/reducers/imageLogic.js